import { getBrand, BrandType } from './brand'
import { getStage, StageType } from './stage'
import { getUrlParam } from './url-param'

export type LoginUrls = {
  loginServiceUrl: string
  loginFailedUrl: string
  loginErrorUrl: string
  successUrl: string
}

export type LoginUrlsMap = {
  [brandKey in BrandType]: {
    qa: LoginUrls,
    live: LoginUrls
  }
}

const loginFailedUrl = `${location.origin}${location.pathname}?error=loginFailed`
const loginErrorUrl = `${location.origin}${location.pathname}?error=loginError`

export const LOGIN_URLS: LoginUrlsMap = {
  'gmx.net': {
    qa: {
      loginServiceUrl: 'https://login-qa.gmx.net/oauth2login',
      loginFailedUrl,
      loginErrorUrl,
      successUrl: 'https://qa.www.gmx.net/produkte/halogin/success/?spfgoto=/premium/trackfree'
    },
    live: {
      loginServiceUrl: 'https://login.gmx.net/oauth2login',
      loginFailedUrl,
      loginErrorUrl,
      successUrl: 'https://www.gmx.net/produkte/halogin/success/?spfgoto=/premium/trackfree'
    }
  },
  'gmx.at': {
    qa: {
      loginServiceUrl: 'https://login-qa.gmx.net/oauth2login',
      loginFailedUrl,
      loginErrorUrl,
      successUrl: 'https://qa.www.gmx.net/produkte/halogin/success/?spfgoto=/premium/trackfree-at'
    },
    live: {
      loginServiceUrl: 'https://login.gmx.net/oauth2login',
      loginFailedUrl,
      loginErrorUrl,
      successUrl: 'https://www.gmx.net/produkte/halogin/success/?spfgoto=/premium/trackfree-at'
    }
  },
  'web.de': {
    qa: {
      loginServiceUrl: 'https://login-qa.web.de/oauth2login',
      loginFailedUrl,
      loginErrorUrl,
      successUrl: 'https://qa.produkte.web.de/halogin/success/?spfgoto=/premium/trackfree'
    },
    live: {
      loginServiceUrl: 'https://login.web.de/oauth2login',
      loginFailedUrl,
      loginErrorUrl,
      successUrl: 'https://produkte.web.de/halogin/success/?spfgoto=/premium/trackfree'
    }
  }
}

export function getLoginUrls(): LoginUrls {
  const portal = getUrlParam('portal')
  // special handling for host gmx.net but portal GMX AT
  const brand = portal === 'gmxat' ? 'gmx.at' : getBrand()
  const stage = getStage()
  const loginStage: StageType = (stage === 'pre' || stage === 'live') ? 'live' : 'qa';

  return LOGIN_URLS[brand][loginStage]
}
